/**
 * Returns the number of whole days a date is overdue.
 * Returns 0 if the date has not yet passed.
 */
export const getDaysOverdue = (dueDate: string | Date): number => {
  return Math.max(
    0,
    Math.floor(
      (Date.now() - new Date(dueDate).getTime()) / (1000 * 60 * 60 * 24),
    ),
  );
};